import Backoffice from "@snark/backoffice"

const context = {
    vlbox: Backoffice.populator("vlbox", {
    }),
};

export default {
    name: "log",
    collection: "log",
    idProperty: "_id",
    section: "app",
    labels: {"singleTitle":"Log","listTitle":"Logs"},
    emptyItem: {
        source: null,
        level: null,
        message: null,
        timestamp: null,
        device: null,
        deviceType: null,
        parameters: [],
    },
    fields: [
        {
            name: "_id",
            label: "Id",
            readOnly: true,
            hideOnCreate: true,
        },
        {
            name: "timestamp",
            label: "Date",
            formatter: Backoffice.formatters.date("DD/MM/YYYY HH:mm:ss"),
            editor: {type: "date"},
        },
        {
            name: "source",
            label: "Source",
        },
        {
            name: "level",
            label: "Level",
        },
        {
            name: "ongoing",
            label: "Etat",
            formatter: (field, item) => {
                if (item.ongoing === true) return "En cours";
                if (item.ongoing === false) return "Résolu";
                return "-";
            },
        },
        {
            name: "message",
            label: "Message",
        },
        {
            name: "device",
            label: "Device",
            formatter: (field, item) => {
                return item.deviceName || (item.device && item.device.name) || item.device || "-";
            },
            editor: context.vlbox.editor(),
        },
        {
            name: "deviceType",
            label: "Device Type",
			formatter: Backoffice.formatters.mapping({"vlbox": "Vlbox", "projector": "Projector", "case": "Case"}),
			editor: {type: "select", options: [{value: "vlbox", label: "Vlbox"}, {value: "projector", label: "Projector"}, {value: "case", label: "Case"}]},
        },
        {
            name: "parameters",
            label: "Parameters",
            list: true,
            children: [
                {name: "name", label: "Name"},
                {name: "value", label: "Value"},
            ],
        },
    ],
    listColumns: [
        {
            name: "timestamp",
            label: "Date",
            formatter: Backoffice.formatters.date("DD/MM/YYYY HH:mm:ss"),
        },
        {name: "source", label: "Source"},
        {name: "level", label: "Level"},
        {
            name: "ongoing",
            label: "Etat",
            formatter: (field, item) => {
                if (item.ongoing === true) return "En cours";
                if (item.ongoing === false) return "Résolu";
                return "-";
            },
            nosingle: true,
        },
        {
            name: "device",
            label: "Device",
            formatter: (field, item) => {
                return item.deviceName || (item.device && item.device.name) || item.device || "-";
            },
            nosingle: true,
        },
        {name: "message", label: "Message"},
        {name: "parameters", label: "Parameters"},
    ],
    loadSingle() { return Promise.all([
        context.vlbox.load(),
    ]); },

    // Trier les logs côté front
    sortItems(items) {
        return items.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    },
};
